import { useState } from 'react';

const faqItems = [
  {
    q: '糖心影视真的免费吗？需要注册吗？',
    a: '糖心影视平台完全免费，无需注册即可在线观看所有影视资源。打开糖心影视网站，选择喜欢的电影电视剧，即点即播，无需任何付费或会员开通。',
  },
  {
    q: '糖心影视支持哪些设备观看？',
    a: '糖心影视网站支持电脑端、平板端和手机端浏览器直接访问，适配各种屏幕尺寸，随时随地畅享高清观影体验。',
  },
  {
    q: '糖心影视的片源清晰度怎么样？',
    a: '糖心影视平台所有资源均提供高清画质，大部分影片支持1080P甚至更高清晰度。我们持续优化播放体验，确保流畅不卡顿。',
  },
  {
    q: '糖心影视多久更新一次内容？',
    a: '糖心影视网站每日实时更新最新电影和热播电视剧。院线新片、热门剧集会第一时间同步上线，让您不错过任何精彩内容。',
  },
  {
    q: '糖心影视的片源安全吗？有广告吗？',
    a: '糖心影视平台所有资源均来自公开网络，仅供学习交流使用。我们致力于提供纯净的观影环境，保障用户观看体验。',
  },
  {
    q: '如何联系糖心影视团队投稿或反馈？',
    a: '您可以通过本站的联系投稿入口与我们取得联系，无论是内容建议、资源投稿还是问题反馈，我们都非常重视每一位用户的意见。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            关于糖心影视平台，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer group"
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors pr-4">
                  {item.q}
                </h3>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                  openIndex === idx ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 md:px-6 pb-5 md:pb-6 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}